// extracted by mini-css-extract-plugin
export default {"header":"SectionListings_header__-Z8ay","title":"SectionListings_title__6-epW","sliderItem":"SectionListings_sliderItem__fRNGY"};